<template>
<div>
  <div class="list-analytics analysis-chart" v-show="mainChartVisible">
    <div class="t-chart c-pointer">
      <div class="title corner" @click="onClickAddButton">
          스토리지 사용률
          <div :class="addButtonIconName"></div>
      </div>
      <w-plot-line-chart ref="diskUserateChart" :active="active" :visible="mainChartVisible" :rscInfoList="mainRscInfoList" @clickChart="onClickChart" />
    </div>
  </div>

  <div v-show="subChartVisible" class="sub-chart-wrapper">
    <div v-for="item in subChartList" :key="item.rscId" class="list-analytics analysis-chart">
      <div class="t-chart">
        <div class="title">{{item.title}}</div>
        <w-plot-line-chart :ref="item.ref" :active="active" :visible="subChartVisible" :rscInfoList="subRscInfo[item.rscId]" @clickChart="onClickChart" />
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { performanceChart } from '@/mixins/performance/charts';
import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
import WPlotLineChart from '@/views/performance/node/analysis/components/PlotLineChart';

// hypervisorType - VMWARE
const vmwareRscInfoList = [{ title: '전체용량', ref: 'totalcapacityChart', rscId: 'TOTALCAPACITY' }, { title: '사용량', ref: 'usecapacityChart', rscId: 'USEDCAPACITY' },
  { title: '가용량', ref: 'avsizeChart', rscId: 'AVSIZE' },
];
// hypervisorType - KVM
const kvmRscInfoList = [{ title: '전체용량', ref: 'totalcapacityChart', rscId: 'TOTALCAPACITY' }, { title: '가용량', ref: 'avsizeChart', rscId: 'AVSIZE' }];

export default {
  name: 'WVmDiskAnalysisChart',
  components: {
    WPlotLineChart,
  },
  mixins: [performanceChart],
  props: {
    chartVisible: Boolean,
  },
  computed: {
    ...mapGetters(['selectedNode']),
  },
  watch: {
    selectedNode: {
      handler(node) {
        if (isEmpty(node)) {
          return;
        }
        if (this.selectedNode.hypervisorType === 'VMWARE' || this.selectedNode.hypervisorType === 'HYPERV') {
          this.subChartList = vmwareRscInfoList;
        } else if (this.selectedNode.hypervisorType === 'KVM') {
          this.subChartList = kvmRscInfoList;
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      mainRscInfoList: [
        {
          rsctypeId: 'VVM_DISK',
          rscId: 'USERATE',
          rscKey: '_',
        },
      ],
      subRscInfo: {
        TOTALCAPACITY: [
          {
            rsctypeId: 'VVM_DISK',
            rscId: 'TOTAL_CAPACITY',
            rscKey: '_',
          },
        ],
        USEDCAPACITY: [
          {
            rsctypeId: 'VVM_DISK',
            rscId: 'USED_CAPACITY',
            rscKey: '_',
          },
        ],
        AVSIZE: [
          {
            rsctypeId: 'VVM_DISK',
            rscId: 'AVSIZE',
            rscKey: '_',
          },
        ],
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/virtual/components/chart/VmDiskAnalysisChart.vue